export default import.meta.ROLLUP_FILE_URL_fB0sydq9LzIdCrzm1PcO1Q;